import SwitchAccount from './SwitchAccount.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'switchAccount', SwitchAccount);
  },
};
